<template>
  <div>
    <div>
      <v-layout row justify-end class="mt-2">
        <v-flex xs3>
          <multiselect
            style="margin-top: 3px;"
            class="mr-0 mr-sm-2"
            @input="onSearch"
            v-model="selectStatus"
            :options="optionStatus"
            label="label"
            placeholder="เลือก"
          ></multiselect>
        </v-flex>

        <v-flex xs9 class="ml-1">
          <InputSearch
            class="mb-3"
            :search="filter"
            @clickSearch="onSearch"
            :placeholder="'ค้นหา'"
          />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold label="แคมเปญ" />
          </v-flex>
          <v-btn
            variant="outlined"
            icon
            :color="'#BECCDB'"
            style="border-radius: 50% !important"
            @click="showCreate"
          >
            <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
          </v-btn>
        </div>
      </v-flex>

      <!-- <v-layout row wrap dense class="ma-0">
        <v-flex xs6>
          <div class="headline primary--text">{{ $t('campaign') }}</div>
        </v-flex>
        <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
          <div class="text-xs-right form-control" style="display: flex; align-items: center">
            <div class="text-xs-center">
              <v-btn
                @click="showCreate"
                color="#152d53"
                small
                outline
                style="color: #152d53; text-transform: capitalize"
                class="px-4"
                ><i class="fas fa-plus mr-2"></i> Add campaign</v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout> -->
      <!-- <div style="display: flex; justify-content: flex-end">
        <div class="depainput form-control mb-3" style="position: relative; width: 40%">
          <input
            v-model="searchText"
            @keyup="searchByText(searchText)"
            style="padding-right: 47px !important"
            type="text"
          />
          <v-btn
            @click="searchByText(searchText)"
            :loading="loading"
            style="position: absolute; right: 0px; top: 0px"
            icon
            ><v-icon color="primary">search</v-icon></v-btn
          >
        </div>
      </div> -->
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        :loading="loading"
        :headers="headers"
        :items="showData"
        select-all
        class="fixTable"
        hide-actions
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow; text-align: center"
              v-for="(header, k) in props.headers"
              :key="header.text + k"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            class="py-3 depatable"
            v-for="(item, kagent) in props.item.agencylist"
            :key="props.index + ' ' + kagent"
          >
            <td
              style="border-right: 1px solid #e3e3e3; vertical-align: baseline"
              v-if="kagent === 0"
              :rowspan="props.item.agencylist.length"
              class="pt-2"
            >
              <div class="text-xs-center">
                <!-- @change="changeStatus(props.item)" -->
                <toggle-button
                  :value="props.item.status"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="statusEdit(props.item)"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </td>
            <td
              style="border-right: 1px solid #e3e3e3; vertical-align: baseline"
              v-if="kagent === 0"
              :rowspan="props.item.agencylist.length"
              class="pt-2"
            >
              <Typography left h5 :label="props.item.id || '-'" />
            </td>

            <td
              style="border-right: 1px solid #e3e3e3; vertical-align: baseline"
              v-if="kagent === 0"
              :rowspan="props.item.agencylist.length"
              class="pt-2"
            >
              <Typography left style="width: 300px" h5 :label="props.item.campaignname || '-'" />
            </td>
            <td>
              <Typography left style="width: 200px" h5 :label="item.agencyname || '-'" />
            </td>
            <td>
              <TagsProvinces :item="item" />
            </td>
            <td><Typography left style="width: 100px" h5 :label="item.couponquantity || '-'" /></td>
            <td><Typography left style="width: 100px" h5 :label="item.couponresidual || '-'" /></td>

            <td v-if="kagent === 0" class="text-xs-right" style="white-space: nowrap">
              <TooltipTable
                :datas="props"
                @modalEdit="showEdit(props.item)"
                @Delete="deleteAgency(props.item.id)"
                showDelete
              ></TooltipTable>
              <!-- <v-btn small @click="showEdit(props.item)" icon outline>
                <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
              </v-btn>
              <v-btn @click="deleteAgency(props.item.campaignid)" small icon outline>
                <v-icon color="primary">delete</v-icon>
              </v-btn> -->
            </td>
            <td v-else></td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <!-- <v-dialog persistent v-model="popDelete" max-width="500">
      <v-card class="p-3">
        <v-card-title class="text-h5 grey lighten-2">
          <h6>ต้องการจะลบใช่หรือไม่</h6>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="delateAgency"> ใช่ </v-btn>
          <v-btn color="danger" text @click="popDelete = false"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="modalStatus" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <!-- <Typography h2 bold label="เปลี่ยนสถานะ" /> -->
            <v-icon style="display: flex; align-items: center" @click="modalStatus = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <div style="text-align: center">
              <img
                :src="
                  modalStatusEdit.status ? '/static/img/statusOFF.png' : '/static/img/statusON.png'
                "
                alt
                class="responsive-img mb-1"
                style="height: 55px"
              />
            </div>
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <!-- <div class="pr-3" style="white-space: nowrap">สถานะ</div> -->
                <Typography
                  bold
                  center
                  h5
                  :label="
                    modalStatusEdit.status
                      ? 'คุณต้องการปิดการเข้าร่วมแคมเปญนี้ใช่หรือไม่'
                      : 'คุณต้องการเปิดการเข้าร่วมแคมเปญนี้ใช่หรือไม่'
                  "
                />
              </v-flex>
            </v-layout>
            <div style="display: flex; justify-content: center">
              <Button
                :loading="loading"
                outline
                :label="$t('cancel')"
                @click="modalStatus = false"
              />
              <Button
                :loading="loading"
                depressed
                :label="$t('Confirm')"
                @click="changeStatus(modalStatusEdit)"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="campaignEditDialog" persistent width="500px">
      <v-card v-if="campaignEditDialog && projectdata">
        <CampaignEdit
          :projectdata="projectdata"
          :agencyOptions="agencyOptions"
          @close="campaignEditDialog = false"
          @onsave="onsave"
          :edittype="campaignEditType"
          :editdata="campaignEditData"
        ></CampaignEdit>
      </v-card>
    </v-dialog>
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import province from '@/assets/js/province'
import CampaignEdit from './CampaignEdit.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import TagsProvinces from '@/components/elements/TagsProvinces.vue'
import Paginations from '@/components/elements/Paginations.vue'
import Template from '../template/template.vue'
// import _ from 'lodash'

export default {
  components: {
    Multiselect,
    CampaignEdit,
    ToggleButton,
    InputSearch,
    Typography,
    Button,
    TooltipTable,
    Paginations,
    Template,
    TagsProvinces
  },
  data() {
    return {
      loading: false,
      agencyOptions: [],
      popDelete: false,
      prepareDelete: null,
      popEdit: false,
      prepareEdit: null,
      editData: [],
      addCampaign: false,
      modalStatusEdit: {},
      selectStatus: [],
      optionStatus: [
        {
          label: 'เปิดการเข้าร่วม',
          value: 'on'
        },
        {
          label: 'ปิดการเข้าร่วม',
          value: 'off'
        }
      ],
      filter: {
        nameAll: ''
      },
      pagination: {
        // rowsPerPage: 999
      },
      projectdata: null,
      modalStatus: false,
      headers: [
        { text: 'สถานะแคมเปญ', align: 'left', value: 'status' },
        { text: 'id', align: 'left', value: 'id' },
        { text: this.$t('campaign name'), align: 'left', value: 'Campaign' },
        { text: this.$t('Agency'), align: 'left', value: 'agency' },
        { text: 'จังหวัด', align: 'left', value: 'province' },
        { text: 'จำนวนคูปองทั้งหมด', align: 'left', value: 'count' },
        { text: 'จำนวนคูปองคงเหลือ', align: 'left', value: 'count' },
        { text: '', align: 'left', value: 'edit' }
      ],
      createCamapign: {
        data: {
          campaignname: '',
          agency: []
        }
      },
      updateCamapign: {
        data: {
          deleteList: [],
          campaignname: '',
          campaignid: null,
          agency: []
        }
      },
      clickCreate: false,
      clickUpdated: false,
      showMore: true,
      data: [],
      showData: [],
      campaignEditType: '',
      campaignEditData: '',
      campaignEditDialog: false,
      page: 1,
      pageTotal: 0,
      rowsPerPage: 12,
      numberPage: {
        page: undefined
      }
    }
  },
  computed: {
    province() {
      return province
    },
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  async mounted() {
    this.initData()
    let project = await this.getProject()
    this.projectdata = project
  },
  methods: {
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.initData()
      let project = await this.getProject()
      this.projectdata = project
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.initData()
        let project = await this.getProject()
        this.projectdata = project
        this.loading = false
      }
    },
    statusEdit(item) {
      this.modalStatus = true
      this.modalStatusEdit = item
    },
    async onSearch() {
      this.page = parseInt(1)
      // this.searchByText(this.filter.nameAll)
      await this.initData()
      let project = await this.getProject()
      this.projectdata = project
    },
    async changeStatus(item) {
      var data = {
        campaignid: item.id,
        campaignname: item.campaignname,

        agency: item.agencylist.map(el => {
          return {
            agencyname: el.agencyname.name,
            id: el.agencyid,
            couponquantity: el.couponquantity,
            provincelist: el.provincelist,
            startdate: el.startdate,
            enddate: el.enddate
          }
        }),
        status: !item.status,
        deleteList: []
      }
      this.loading = true
      var response = await api['updatedepacampaign'](data)
      var index = this.showData.findIndex(el => el.id == item.id)
      this.showData[index].status = !item.status
      this.modalStatus = false
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })
      this.loading = false
    },
    getProject() {
      return new Promise(resolve => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    initData() {
      this.getcampaignwithagency()
      this.getDataAgent()
    },
    onsave() {
      this.initData()
      this.campaignEditDialog = false
    },
    showCreate() {
      this.campaignEditType = 'create'
      this.campaignEditDialog = true
    },
    showEdit(item) {
      this.campaignEditType = 'edit'
      this.campaignEditData = item
      this.campaignEditDialog = true
    },
    getDataAgent() {
      var data = {
        pageid: this.selectedBot.pageid
      }

      this.loading = true
      api.getDepaAgencyMaster(data, (err, response) => {
        this.loading = false
        this.agencyOptions = response.data
      })
    },
    clickDelete(id) {
      this.popDelete = true
      this.prepareDelete = id
    },
    clickEdit(id) {
      this.editData = []
      this.closeEdit()
      let filterData = this.showData.filter(data => {
        return data.id == id
      })
      this.editData = filterData
      this.updateCamapign.data.campaignname = this.editData[0].campaignname
      this.updateCamapign.data.id = this.editData[0].id
      this.editData.forEach(ele => {
        let obj = {
          id: ele.agencyid,
          agencyname: ele.agencyname,
          couponquantity: ele.couponquantity,
          provincelist: []
        }
        obj.provincelist = ele.provincelist.split(',')
        this.updateCamapign.data.agency.push(obj)
      })
      this.popEdit = true
      this.prepareEdit = id
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    addAgency() {
      this.createCamapign.data.agency.push({
        agencyname: '',
        provincelist: [],
        couponquantity: 0
      })
    },
    addAgencyInUpdate() {
      this.updateCamapign.data.agency.push({
        agencyname: '',
        provincelist: [],
        couponquantity: 0
      })
    },
    async deleteAgency(id) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ?',
          showCancelButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deletedepacampaign(id)
            if (res == 204) {
              this.initData()
            }
          }
        })
    },
    async removeAgency(index) {
      this.createCamapign.data.agency.splice(index, 1)
    },
    async removeAgencyInEdit(index) {
      if (this.updateCamapign.data.agency[index].id) {
        this.updateCamapign.data.deleteList.push(this.updateCamapign.data.agency[index].id)
      }
      this.updateCamapign.data.agency.splice(index, 1)
    },
    async saveCampaign() {
      if (this.createCamapign.data.campaignname && this.createCamapign.data.agency.length) {
        for (let i = 0; i < this.createCamapign.data.agency.length; i++) {
          if (
            !this.createCamapign.data.agency[i].agencyname ||
            !this.createCamapign.data.agency[i].couponquantity ||
            !this.createCamapign.data.agency[i].provincelist.length
          ) {
            this.clickCreate = true
            return
          }
        }
        try {
          let res = await api.createdepacampaign(this.createCamapign.data)

          if (res == 204) {
            this.createCamapign.data.agency = []
            this.createCamapign.data.campaignname = ''
            this.addCampaign = false
            this.clickCreate = false
            this.getcampaignwithagency()
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.clickCreate = true
      }
    },
    async updateCampaign() {
      if (this.updateCamapign.data.campaignname && this.updateCamapign.data.agency.length) {
        for (let i = 0; i < this.updateCamapign.data.agency.length; i++) {
          if (
            !this.updateCamapign.data.agency[i].agencyname ||
            !this.updateCamapign.data.agency[i].couponquantity ||
            !this.updateCamapign.data.agency[i].provincelist.length
          ) {
            this.clickUpdated = true
            return
          }
        }
        try {
          let res = await api.updatedepacampaign(this.updateCamapign.data)

          if (res == 204) {
            this.closeEdit()
            this.addCampaign = false
            this.clickUpdated = false
            this.getcampaignwithagency()
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.clickUpdated = true
      }
    },
    async getcampaignwithagency() {
      let filter = {
        nameAll: this.filter.nameAll ? this.filter.nameAll : '',
        channel: 'cms',
        status:
          this.selectStatus && this.selectStatus.value === 'on'
            ? true
            : this.selectStatus.value === 'off'
            ? false
            : '',
        limit: this.limitCom,
        offset: this.offsetCom
      }

      try {
        this.data = await api.getcampaignwithagency(filter)
        this.pageTotal = this.data.total ? this.data.total : []
        this.data = this.data.data
        this.showData = this.data.map(item => ({
          ...item,
          agencylist: item.agencylist.map(agencyItem => ({
            ...agencyItem,
            provincelist: agencyItem.provincelist.split(',')
          }))
        }))
        console.log('this.showData', this.showData)
      } catch (error) {
        console.error(error)
      }
    },
    // searchByText(text) {

    //   if (text == '' && this.selectStatus.value === undefined) {
    //     this.showData = this.data
    //     return
    //   }
    //   let output = []

    //   this.data.forEach((ele) => {
    //     if (ele.campaignname.match(text)) {
    //       output.push(ele)
    //     } else if (ele.agencylist.length) {
    //       ele.agencylist.forEach((agen) => {
    //         if (agen.agencyname.match(text) || agen.provincelist.match(text)) {
    //           output.push(ele)
    //           return
    //         }
    //       })
    //     }
    //   })

    //   console.log('this.data', this.data)
    //   console.log('output', output)
    //   this.showData = output
    // },
    closeEdit() {
      ;(this.editData = []), (this.prepareEdit = null)
      this.popEdit = false
      this.updateCamapign = {
        data: {
          deleteList: [],
          campaignname: '',
          id: null,
          agency: []
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/Campaign.vue